import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';
import { QuestionExceptionConfig } from './questionException';

export enum TimeType {
  StartEndTimes = 'START_END_TIMES',
  TimeOnly = 'TIME_ONLY',
  DateOnly = 'DATE_ONLY',
}
export interface TimeQuestionConfig
  extends WorkflowQuestionConfig,
    TimeQuestionConfigBase,
    QuestionExceptionConfig {}

export interface TimeResponseState
  extends WorkflowResponseState,
    TimeQuestionConfigBase {}

interface TimeQuestionConfigBase {
  timeType: TimeType;
  timeTypeValue?: string | StartEndTimes;
}

export interface StartEndTimes {
  startTime: string;
  endTime: string;
}
